export default __webpack_public_path__ + "static/media/hand-right-front.bf5f7ee1.png";